// redux/slices/configSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { pullConfig } from '../actions';

interface ConfigState {
    config: any;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null; // Allow error to be either a string or null
}

const initialState: ConfigState = {
    config: {},
    status: 'idle',
    error: null, // Error starts as null
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(pullConfig.pending, (state) => {
                state.status = 'loading';
                state.error = null; // Clear error when starting new request
            })
            .addCase(pullConfig.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.config = action.payload;
                state.error = null; // Clear error on success
            })
            .addCase(pullConfig.rejected, (state, action) => {
                state.status = 'failed';
                // Assign a default error message if `action.error.message` is undefined
                state.error = action.error.message ?? 'An unknown error occurred';
            });
    },
});

export const selectConfig = (state: { config: ConfigState }) => state.config.config; // Selector for config
export const selectConfigStatus = (state: { config: ConfigState }) => state.config.status;
export const selectConfigError = (state: { config: ConfigState }) => state.config.error;


export default configSlice.reducer;
